import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import ReviewPage from "./ReviewPage";

function EchoServices() {
  return (
    <>
      <div id="echo-services"></div>
      <Header />
      <section className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              ECHOCARDIOGRAM (ECHO)
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get An Echocardiogram Services at Rapid Lab Diagnostics
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  An echocardiogram (Echo) is a non-invasive medical imaging
                  test that uses ultrasound waves to create detailed images of
                  the heart’s structure and function. It helps evaluate heart
                  chambers, valves, and blood flow, aiding in the diagnosis of
                  various cardiac conditions. At Rapid Lab Diagnostics, we offer
                  expert Echo services using advanced technology to provide
                  accurate and reliable results. Our skilled technicians ensure
                  a comfortable experience while delivering high-quality care.
                  Whether you need an Echo for routine screening or to
                  investigate specific symptoms, our team is here to support
                  your heart health with compassionate care and precise
                  diagnostics. Contact us today to schedule your Echo
                  appointment and take a proactive step towards maintaining your
                  cardiovascular health.
                </p>

                <p className="text-primary-emphasis">
                  {" "}
                  If you are seeking Echo services, Rapid Lab Diagnostics is
                  here to provide you with expert care, advanced technology, and
                  a compassionate approach to meet your healthcare needs.
                  Contact us today to schedule your appointment and experience
                  the difference in quality and care that we offer.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center pt-3">
                <img
                  src="images/assets/echo-pic.png"
                  alt="echo"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    src="https://rgshealthcare.com/wp-content/uploads/2024/05/1200px_rgsHealthCare_AdobeStock_405836547-768x512.jpg"
                    alt="lab1"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/monitor-hospital-ward-showing-bmp-from-patient.jpg"
                    alt="ecg"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src="images/assets/heart.jpg"
                    alt="lab3"
                    loading="lazy"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      During an echocardiogram, a trained technician will apply
                      a gel to your chest and use a transducer (a small handheld
                      device) to send ultrasound waves into your body. The
                      transducer will capture the echoes of the sound waves as
                      they bounce off your heart structures, creating real-time
                      images on a monitor. This allows doctors to assess the
                      size, shape, and movement of your heart chambers and
                      valves, as well as the blood flow through your heart. The
                      procedure is painless, non-invasive, and typically takes
                      about 30 to 60 minutes to complete. It provides valuable
                      information for diagnosing and managing various cardiac
                      conditions, helping you maintain optimal heart health. If
                      you would like to know more about your upcoming exam or
                      procedure, please contact us for a more detailed
                      description.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn btn-outline-primary text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reasons for An Echocardiogram (Echo)
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>
                <p className=" px-3 row align-items-center text-primary-emphasis fw-semibold  fs-4">
                  Why You Might Need an Echocardiogram
                </p>
                <p className="text-primary-emphasis">
                  Echocardiogram (Echo) is a simple, non-invasive test that uses
                  ultrasound waves to create detailed images of the heart’s
                  structure and function. It is commonly used to diagnose
                  various cardiac conditions and monitor heart health over time.
                  Here are some common reasons why you might need an
                  echocardiogram:
                </p>
                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}Diagnosing the cause of symptoms like shortness of
                        breath, chest pain or pressure, arrhythmia, fatigue or
                        weakness, edema, ankle swelling, or a heart murmur.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Obtain detailed information about the structure,
                        function, blood flow, and valves of the hear.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Detect problems like blood clots, fluid around the
                        heart, or tumorsDetect problems like blood clots, fluid
                        around the heart, or tumors
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Diagnose or monitor conditions like heart failure, heart
                        valve disease, cardiomyopathy, endocarditis, heart
                        defects, and heart damage
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you are seeking Echocardiogram services, Rapid Lab
                  Diagnostics is here to provide you with expert care, advanced
                  technology, and a compassionate approach to meet your
                  healthcare needs. Contact us today to schedule your
                  appointment and experience the difference in quality and care
                  that we offer.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/african-american-specialist-cardiologist-explaining.jpg"
                  alt="exercise"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}
            <ReviewPage />
            <div className="container text-center py-2 bg-muted  ">
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    src="images/assets/medical-office-scene-doctor-patient-evaluating-cardiology-test-results.jpg"
                    alt="rapidLabEnterance"
                    loading="lazy"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose Rapid Lab Diagnostics for Your Echocardiogram
                    Services
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    At Rapid Lab Diagnostics, we are committed to providing
                    exceptional ECG services with a focus on patient care,
                    accuracy, and comfort. Our state-of-the-art facilities are
                    equipped with the latest technology to ensure precise
                    diagnostics, while our experienced team of healthcare
                    professionals is dedicated to delivering compassionate care
                    tailored to your individual needs. We understand that
                    undergoing medical tests can be stressful, which is why we
                    strive to create a welcoming and supportive environment for
                    all our patients. From the moment you walk through our
                    doors, you can expect personalized attention and expert
                    guidance throughout your ECG experience.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  Echocardiogram Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an Echocardiogram session?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      During an Echocardiogram procedure, a trained technician
                      will use an ultrasound device to create detailed images of
                      your heart. This non-invasive test helps doctors evaluate
                      your heart's structure and function. The technician will
                      apply a gel to your chest and use a transducer to capture
                      images of your heart in motion. The test is generally
                      quick and painless, typically taking only a few minutes to
                      complete. The images obtained can provide valuable
                      information about your heart's pumping ability, valve
                      function, and overall health.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for an Echocardiogram session?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      No special preparation is usually needed for an
                      Echocardiogram. You can eat, drink, and take your
                      medications as usual before the test. However, it’s a good
                      idea to avoid caffeine and smoking for a few hours before
                      the procedure, as they can affect your heart rate and
                      potentially influence the results. It’s also recommended
                      to wear comfortable clothing that allows easy access to
                      your chest area, as electrodes will need to be attached
                      there. If you have any specific concerns or questions
                      about preparing for your Echocardiogram, our team at Rapid
                      Lab Diagnostics is here to provide you with guidance and
                      support to ensure you feel comfortable and informed before
                      your appointment.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Is an Echocardiogram safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Yes, Echocardiogram is a safe and non-invasive procedure.
                      It does not involve any radiation and is generally
                      painless. The electrodes used to record the heart’s
                      electrical activity are simply placed on the skin and do
                      not cause any harm. Some people may experience mild
                      discomfort from the adhesive used to attach the electrodes
                      or from lying still during the test, but these sensations
                      are typically temporary and minor. If you have any
                      specific concerns about the safety of an Echocardiogram,
                      our team at Rapid Lab Diagnostics is available to address
                      your questions and provide you with the information you
                      need to feel confident and comfortable about your upcoming
                      procedure.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default EchoServices;
